import React from 'react';
import { useSelector } from 'react-redux';
import { Entity } from '@debbie/common/dist';
import { selectTemplatesMap } from '@debbie/cortex/dist/templates/selectors';
import { Badge, Email, Modal, Panel } from '..';
import THEME from '../../theme';
import DefaultSummary from './DefaultSummary';
import EmailThread from '../threads/EmailThread';
import styled from 'styled-components';
import EmailInteraction from '../interactions/EmailInteraction';
const EmailSummary = (props) => {
    var _a, _b;
    const lang = useSelector((s) => s.lang);
    const template = useSelector((s) => {
        const templatesMap = selectTemplatesMap(s);
        return ((props.interaction.templateId &&
            templatesMap[props.interaction.templateId]) ||
            null);
    });
    return (React.createElement(DefaultSummary, Object.assign({}, props),
        React.createElement("div", { style: { position: 'relative' } },
            template && (React.createElement(React.Fragment, null,
                React.createElement("p", { style: {
                        fontWeight: '900',
                        margin: '0 0 0.8em',
                    } }, template.name),
                !!((_a = template.tags) === null || _a === void 0 ? void 0 : _a.length) && (React.createElement("p", { style: { marginTop: 0 } }, template.tags.map(({ tag }) => (React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, lang.templateTags[tag]))))))),
            React.createElement(Email, { interaction: props.interaction }),
            React.createElement("br", null),
            props.replying && (React.createElement(Modal, { header: lang.interactions.reply, onToggle: () => {
                    if (props.setReplying) {
                        props.setReplying(false);
                    }
                } },
                React.createElement(Wrapper, null,
                    React.createElement(Panel, null,
                        React.createElement(EmailInteraction, { referenceId: props.interaction.referenceId, referenceType: Entity.Case, emailTo: props.interaction.details.from, emailToEditable: true, inReplyTo: (_b = props.interaction.details.imapId) !== null && _b !== void 0 ? _b : undefined, defaultSubject: `Re: ${props.interaction.details.subject}`, references: (props.interaction.details.references
                                ? `${props.interaction.details.references} `
                                : '') + `${props.interaction.details.imapId}`, onSent: () => {
                                if (props.setReplying) {
                                    props.setReplying(false);
                                }
                            } })),
                    React.createElement(Panel, { header: lang.interactions.replyingTo },
                        React.createElement(Email, { interaction: props.interaction }))))),
            props.showThread && props.longCaseId && (React.createElement(Modal, { header: lang.interactions.emailThread, onToggle: () => {
                    if (props.setShowThread) {
                        props.setShowThread(false);
                    }
                } },
                React.createElement(EmailThread, { caseId: props.longCaseId, referenceInteraction: props.interaction.id }))))));
};
const Wrapper = styled.div `
  background: ${THEME.BACKGROUND};
  padding: 1em;
`;
export default EmailSummary;
//# sourceMappingURL=EmailSummary.js.map